import { DenormalizedCustomizableQuestion } from '@packages/types'
import React, { FocusEventHandler } from 'react'
import { useSelector } from 'react-redux'

import * as questionPanelSelectors from 'customizer/questionPanel/selectors'
import useThemeSettings from 'customizer/theme/useThemeSettings'
import WarningIcon from 'icons/bold/47-Transportation/27-Signs/road-sign-warning.svg'
import CommonDropdownQuestion from 'themes/common/components/questions/dropdown/DropdownQuestion'
import SanitizedHtml from 'themes/common/components/SanitizedHtml'

const { showInteractionRequiredWarningsSelector } = questionPanelSelectors

import './DropdownQuestion.scss'

interface DropdownQuestionProps {
  question: DenormalizedCustomizableQuestion
  selectAnswer: (answerId: string) => void
  selectAnswers: (answerIds: string[]) => void
  focusQuestion: FocusEventHandler<HTMLSelectElement>
  lang?: string
  country?: string
  pricing: Record<string, string>
  currency: string
  requiredWarning?: boolean
  answersOutOfStock: string[]
}

const DropdownQuestion = (props: DropdownQuestionProps) => {
  const style = useThemeSettings('textInputAndDropdown')
  const price = useThemeSettings('price')
  const answerStyle = useThemeSettings('answer')
  const { linkColor } = useThemeSettings('questionPanel')

  const interactionRequired = props.question.isInteractionRequired && !props.question.hadInteraction

  const showInteractionRequiredWarnings = useSelector(showInteractionRequiredWarningsSelector)

  const showInteractionRequiredMessage = showInteractionRequiredWarnings && interactionRequired

  const handleSelectAnswer = (answerId: string) => {
    props.selectAnswer(answerId)
  }

  return (
    <div className="dropdown-question">
      <CommonDropdownQuestion
        {...props}
        answersOutOfStock={props.answersOutOfStock}
        onFocus={props.focusQuestion}
        textInputAndDropdownStyle={style}
        className={showInteractionRequiredMessage ? 'error' : ''}
        showExtraPrice={price.showExtraPrice}
        selectAnswer={handleSelectAnswer}
      >
        {showInteractionRequiredMessage && <WarningIcon className="icon warning" />}
      </CommonDropdownQuestion>
      {props.question.selectedAnswer?.showDescription &&
        props.question.selectedAnswer?.description &&
        !interactionRequired && (
          <div
            className="dropdown-question__description"
            data-testid="dropdown-question-description"
            style={{
              color: answerStyle.descriptionTextColor,
              fontSize: answerStyle.descriptionFontSize,
              fontFamily: answerStyle.descriptionFontFamily?.fontFamily,
            }}
          >
            <SanitizedHtml
              dirtyHtml={props.question.selectedAnswer?.description}
              tagsStyle={{ a: `color: ${linkColor};` }}
            />
          </div>
        )}
    </div>
  )
}

export default DropdownQuestion
